function createPopups() {
  const rioPopups = document.querySelector(".rio-popup");
  if (rioPopups) return;
  const popups = window.popups;

  const titles = document.querySelectorAll(".rio-product-option-title");
  const wrapper = document.createElement("div");
  wrapper.classList.add("popup__wrapper", "hide");
  document.body.appendChild(wrapper);

  titles.forEach((title) => {
    const firstWord = title.innerText.split(" ")[0].replace(":", "");
    const popup = popups.find(
      (popup) => popup.option.toLowerCase() === firstWord.toLowerCase()
    );
    if (popup) {
      const popupElement = document.createElement("div");
      const linkElement = document.createElement("span");
      const headerElement = document.createElement("div");
      const titleElement = document.createElement("span");
      const closeElement = document.createElement("span");
      const popupContentElement = document.createElement("div");
      const directParent = title.parentElement;

      closeElement.classList.add("rio-popup-close");
      popupContentElement.classList.add("rio-popup-content");

      headerElement.classList.add("rio-popup-header");
      titleElement.classList.add("rio-popup-title");
      titleElement.innerText = popup.link;
      headerElement.appendChild(titleElement);
      headerElement.appendChild(closeElement);

      popupElement.classList.add("rio-popup", "hide");
      popupElement.id = `rio-popup-${popup.option.toLowerCase()}`;
      popupElement.appendChild(headerElement);
      popupElement.appendChild(popupContentElement);
      popupContentElement.innerHTML = popup.page;

      linkElement.classList.add("rio-popup-link");
      linkElement.id = `rio-popup-link-${popup.option.toLowerCase()}`;
      linkElement.innerText = popup.link;

      directParent.classList.add("rio-popup-parent");

      wrapper.appendChild(popupElement);
      directParent.appendChild(linkElement);

      linkElement.addEventListener("click", function () {
        wrapper.classList.remove("hide");
        const popup = document.getElementById(
          `rio-popup-${this.id.split("-")[3]}`
        );
        popup.classList.toggle("hide");

        document.documentElement.style.overflow = "hidden";

        document.addEventListener("click", (event) => {
          if (event.target.classList.contains("rio-popup-link")) return;
          const currentPopup = document.querySelector(".rio-popup:not(.hide)");
          if (
            !currentPopup.contains(event.target) ||
            event.target.classList.contains("rio-popup-close")
          ) {
            wrapper.classList.add("hide");
            popup.classList.add("hide");
            document.documentElement.style.overflow = "auto";
            document.documentElement.style.overflowX = "hidden";
          }
        });
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", createPopups);
window.addEventListener("load", createPopups);
